import React from 'react';
import { useTranslation } from 'react-i18next';

const EnterpriseSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className='enterpriseSection'>
      <div className='enterpriseContent'>
        <h2 className='enterpriseTitle'>{t('enterprise.header')}</h2>
        <p className='enterpriseDescription'>{t('enterprise.description')}</p>
      </div>
      <a
        id='enterpriseSectionCtaLink'
        href='https://www.businesskitz.com/contact'
        className='enterpriseCta'
        target='_blank'
        rel='noreferrer'
      >
        {t('enterprise.cta')}
      </a>
    </section>
  );
};

export default EnterpriseSection;
